export const TRAINING_CONTRIBUTION_LINK = 'https://github.com/Toyota-Motor-North-America/ace-self-service-content/blob/master/README.md';
export const TRAINING_REQUEST_LINK = 'https://github.com/Toyota-Motor-North-America/ace-self-service-content/discussions/categories/ideas';
